 export default {
  title: "Forgot Password",
  description: "Please enter your account's email address in order to retrieve your forgotten password",
  emailPlaceholder: "Email address",
  submitButton: "Retrieve Your Password",
  loginLink: "Back to login page"
}